import { render, staticRenderFns } from "./HeaderSubmenu.vue?vue&type=template&id=565842c5&scoped=true&"
import script from "./HeaderSubmenu.vue?vue&type=script&lang=js&"
export * from "./HeaderSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565842c5",
  null
  
)

export default component.exports